import { useEffect, useState } from "react";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _SupplierPaymentOrder } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { PrintJson } from "../../../theme/Component/PrintJson";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";

import { SuppliertPaymentOptions } from "../SuppliertPaymentOptions";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { ThirdBankingAccountEditor } from "../../ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { SelectorRPBudgetContract } from "../../../contract/etapa-contrato/contrac/adquisitionContractRP/SelectorRPBudgetContract";
import { StepWizard, Wizard } from "../../../bpm/config/Componentes/wizard/Wizard";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SupplierPaymentOrderItem } from "../SupplierPaymentOrderItem/SupplierPaymentOrderItem";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ErrorList } from "../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
interface Props {
    _AdquisitionContrac: any;
}
export const SupplierPaymentOrder = ({ _AdquisitionContrac }: Props) => {

    const { instance, bean, setBean, lista, setLista, update, handleChange } = useDataBean(_SupplierPaymentOrder);
    const [row, setRow] = useState<any>({});
    const [ubl, setUBL] = useState<any>({});
    const [addBudget, setAddBudget] = useState<boolean>(true);

    const [modalItems, setModalItems] = useState<any>({ name: 'Items de Obligacion Presupuestal', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalOB, setModalOB] = useState<any>({ name: 'Documento de Obligacion Presupuestal', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Documento de Obligacion Presupuestal', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalEditar = useModal("Orden", MODAL_LG);

    const head = [
        { title: 'ID', property: 'IDSupplierPaymentOrder', visible: true, mask: MASK_NUMBER },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Valor de la Orden de Pago', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Solicitante', property: 'UserEntity', visible: true, },
        { title: '¿Usa Presupuesto?', property: 'UseBudget', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Obligación Presupuestal', property: 'OBEntity', visible: true },
    ]

    // const head = [
    //     { title: 'ID', property: 'IDSupplierPaymentOrder', visible: false, mask: MASK_NUMBER },
    //     { title: 'Descripción', property: 'Description', visible: true },
    //     { title: 'Valor de la Orden de Pago', property: 'Value', visible: true, mask: MASK_MONEY },
    //     { title: 'No Factura', property: 'InvoiceID', visible: true },
    //     { title: 'Proveedor Factura', property: 'SupplierName', visible: true },
    //     { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
    //     { title: 'Vr Factura', property: 'UBLInvoiceValue', visible: true, mask: MASK_MONEY },
    //     { title: 'Fecha Creación', property: 'SupplierPaymentOrderDate', visible: true, mask: MASK_DATE },
    //     { title: 'Etapa de la Orden', property: 'OrderStateName', visible: true },
    //     { title: 'Estado', property: 'StateName', visible: false },
    //     { title: 'Creado por', property: 'EmployeeName', visible: true },
    //     { title: 'Radica Factura', property: 'FilerName', visible: true },
    //     { title: 'Fecha Radicación Factura', property: 'FiledDate', visible: true },
    //     { title: 'Registro Presupuestal', property: 'RPDocumentName', visible: true },
    // ]

    useEffect(() => {

        getLista()
        typeUpdateItem();

    }, [_AdquisitionContrac])

    const getLista = () => {

        instance.getSupplierPaymentOrderCatalogForAdquisitionContract(_AdquisitionContrac.IDAdquisitionContract, _AdquisitionContrac.AdquisitionContractDate).then(
            (resp: any) => {
                if (resp) {

                    const response = resp;

                    response.forEach(element => {
                        element.DataBeanProperties.UserEntity = `${element.DataBeanProperties.EmployeeID ?? "N/A"} - ${element.DataBeanProperties.EmployeeName ?? "N/A"}`;
                        element.DataBeanProperties.OBEntity = element.DataBeanProperties.OBIDDocument ? `${element.DataBeanProperties.OBMnemonic ?? "N/A"} - ${element.DataBeanProperties.OBConsecutive ?? "N/A"}` : "No Generado";
                    });

                    setLista(resp)
                    //console.log(resp)
                }
            }
        ).catch(err => console.error(err))

    }

    const typeUpdateItem = () => {
        instance.useBudget(null).then(
            (resp) => {
                setAddBudget(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error(err)
            }
        )
    }

    const create = () => {

        modalEditar.open();
        setUBL({})
        setBean({
            Type: 2,
            IDAdquisitionContract: _AdquisitionContrac.IDAdquisitionContract,
            AdquisitionContractDate: _AdquisitionContrac.SeleccionDate,
            IDEmployee: _single.getAccountID(),
            SupplierPaymentOrderDate: _single.getCurrenDate()
        });


    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]


    const deleteItem = () => {
        instance.deleteSupplierPaymentOrder(row.IDSupplierPaymentOrder, row.SupplierPaymentOrderDate).then(
            (resp) => {
                //console.log(resp);
                getLista();

                setModalC({ ...modalC, "view": false });
            }
        )
    }

    const editaItem = () => {
        if (bean.SupplierPaymentOrderDate && bean.IDThirdBankingAccount && bean.Description) {
            instance.updateSupplierPaymentOrder(bean).then(
                (resp: any) => {
                    // console.log(resp)
                    getLista();
                    setUBL(resp)
                }
            ).catch(err => {
                toast.error(err);
            })
        } else {
            toast.error("Los Campos son obligatorios")
        }
    }

    // const [listaBotones, setListaBotones] = useState<any>([]);

    const formPaymentOrder = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <label>Fecha de Registro de la Orden de Pago</label>
                    <InputDate name=" " value={bean.SupplierPaymentOrderDate} setDate={(e) => { setBean({ ...bean, "SupplierPaymentOrderDate": e }) }} />
                </div>
                <div className="col-md-12">
                    <ThirdBankingAccountEditor label="Cuenta Bancaria del Tercero" idSelector={bean.IDThirdBankingAccount} idselectorAccount={_AdquisitionContrac.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDThirdBankingAccount": e }) }} />
                </div>
                <div className="col-md-12">
                    <label>Justificación del Pago</label>
                    <textarea name="Description" className="form-control" rows={5} value={bean.Description} onChange={handleChange} />
                </div>
                {addBudget &&
                    <div className="col-md-12">
                        <SelectorRPBudgetContract paymentDate={bean.SupplierPaymentOrderDate} adquisitionContract={_AdquisitionContrac} onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPDocumentDate": e.DocumentDate }) }} label="Registro Presupuestal" />
                    </div>
                }
            </div>
        )
    }

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children:
                <div className="row">
                    <div className="col-md-12">
                        {formPaymentOrder()}
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton eventClick={editaItem} icon="ri-save-line" children={`${ubl?.IDSupplierPaymentOrder ? "Actualizar" : "Crear Orden de pago"}`} />
                    </div>
                </div>
            ,
            validButton: ubl?.IDSupplierPaymentOrder,
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Items de la Factura',
            onEvent: () => { },
            children: <SupplierPaymentOrderItem SupplierPaymentOrder={ubl} onUpdate={() => { getLista() }} />,
            validButton: false,
            canReturn: true
        },
    ]

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);

    const GenerarOB = () => {
        instance.createOBForSupplierPaymentOrder(row.IDSupplierPaymentOrder, row.SupplierPaymentOrderDate, bean.Consecutive, _single.getAccountID()).then(
            (resp: any) => {
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setModalOB({ ...modalOB, "view": true })
                getLista();
                setBean({});
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const genOB = () => {
        setModal({ ...modal, "view": true, "name": "Generar Obligación Presupuestal" });
        setBean({})
    }

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { modalEditar.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: (_single.canDelete() && !row.OBIDDocument), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Generar Obligacion Presupuestal', icono: 'ri-file-list-3-fill', visible: (!row.OBIDDocument), evento: () => { genOB() } },
            { titulo: 'Items de la Orden de Pago', icono: 'ri-list-check', visible: (!row.OBIDDocument), evento: () => { setModalItems({ ...modalItems, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (

        <div className="row">
            {/* <div className="col">
                <SuppliertPaymentOptions key={row} contract={_AdquisitionContrac} paymentOrder={row} listComponent={setListaBotones} updateList={getLista} />
            </div> */}
            <div className="col-md-12">
                <p>{_AdquisitionContrac.Description}</p>
                <BasicTable body={lista} head={head} rowSet={setRow} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>

                <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} >
                    <Wizard title=" " listStep={steps} />
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">


                <ModalConfirm modal={modal} updateModal={setModal} eventModal={GenerarOB}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Consecutivo Externo</label>
                            <input type="number" className="form-control" value={bean.Consecutive} onChange={(e) => { setBean({ ...bean, "Consecutive": e.target.value }) }} />
                        </div>
                    </div>
                </ModalConfirm>

            </div>
            <div className="col-md-12">
                <Modal modal={modalOB} updateModal={setModalOB}  >
                    <div className="row">
                        <div className="col">
                            {msgList?.length > 0 &&
                                <ErrorList lista={msgList} />
                            }
                            {msgList?.length === 0 && documents.length > 0 &&
                                <DocumentViewer key={documents} list={documents} />
                            }
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalItems} updateModal={setModalItems}  >
                    <SupplierPaymentOrderItem SupplierPaymentOrder={row} onUpdate={() => { getLista() }} />
                </Modal>
            </div>
        </div>

    )
}